// v2 - superadmin login support
import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { useTheme } from '../context/ThemeContext'

type Role = 'admin' | 'trader' | null

const roleAccounts: Record<string, string[]> = {
  admin: ['admin', 'superadmin'],
  trader: [],
}

export function Login() {
  const { login } = useAuth()
  const { theme, toggleTheme } = useTheme()
  const [role, setRole] = useState<Role>(null)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const ok = await login(username, password)
    setLoading(false)
    if (!ok) setError('Invalid credentials')
  }

  const selectRole = (r: Role) => {
    setRole(r)
    setError('')
    setPassword('')
    setUsername('')
  }

  if (!role) {
    return (
      <div className="login-page">
        <div className="login-bg">
          <div className="login-orbe login-orbe-1" />
          <div className="login-orbe login-orbe-2" />
          <div className="login-orbe login-orbe-3" />
        </div>
        <button className="login-theme-toggle" onClick={toggleTheme} title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}>
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
        <div className="login-card">
          <div className="login-header">
            <img src="/logo.png" alt="LaMoney" className="login-logo-img" />
            <h1>LaMoney</h1>
            <p>Algorithmic Trading Platform</p>
          </div>
          <div className="role-selector">
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.8125rem', marginBottom: '1.25rem' }}>
              Select your role to continue
            </p>
            <div className="role-grid">
              <button className="role-card" onClick={() => selectRole('admin')}>
                <span className="role-icon">⚙</span>
                <strong>Admin</strong>
                <small>Manage users, strategies, brokers & view all positions</small>
              </button>
              <button className="role-card" onClick={() => selectRole('trader')}>
                <span className="role-icon">📈</span>
                <strong>Trader</strong>
                <small>Run execution sets, monitor MTM & manage positions</small>
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-orbe login-orbe-1" />
        <div className="login-orbe login-orbe-2" />
        <div className="login-orbe login-orbe-3" />
      </div>
      <div className="login-card">
        <div className="login-header">
          <span className="login-logo">⟐</span>
          <h1>LaMoney</h1>
          <p style={{ textTransform: 'capitalize' }}>{role} sign in</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>Username</label>
            {roleAccounts[role].length > 0 ? (
              <select value={username} onChange={(e) => setUsername(e.target.value)} className="cfg-input">
                <option value="">— select account —</option>
                {roleAccounts[role].map((u) => (
                  <option key={u} value={u}>{u}</option>
                ))}
              </select>
            ) : (
              <input type="text" placeholder="Enter username" value={username}
                onChange={(e) => setUsername(e.target.value)} autoComplete="username" />
            )}
          </div>
          <div className="login-field">
            <label>Password</label>
            <input type="password" placeholder="pass" value={password}
              onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <div className="login-error">{error}</div>}
          <div className="login-form-actions">
            <button type="button" className="btn btn-ghost btn-sm" onClick={() => setRole(null)}
              style={{ alignSelf: 'flex-start' }}>← Back</button>
            <button type="submit" className="login-btn" disabled={loading || !username}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
